
export const FIELD_EMPTY = "が未入力です。"
export const NOT_EXIST = "が存在しません。"
export const ERROR_RETRIEVE = "の取得中にエラーが発生しました。"
export const NOT_VALID = "は無効です。"
export const GREATER_THAN_ZERO = "は 0 以上を入力してください。"
export const REQUIRED = "は必須です。"

export const ERROR_CREATE = "の挿入に失敗しました。"
export const ERROR_UPDATE = "の更新に失敗しました。"
export const ERROR_DELETE = "の削除に失敗しました。"

/* LOGIN */
/*Error Messages*/
export const ERROR_REQUIRED_FIELDS = "全て必須項目です。"
export const ERROR_MIN_8_CHARS = "項目は 8 文字以上必要です。"
export const ERROR_OLD_AND_NEW_PASS = "[現在のパスワード]と[新しいパスワード]が同じです。"
export const ERROR_NEW_PASS_AND_USERNAME = "[ログインID]と同じ[新しいパスワード]は使用できません。"
export const ERROR_INVALID_USERNAME_PAS = "[ログインID]／[パスワード]が無効です。"
export const ERROR_PASS_CHANGE = "[パスワード]の変更に失敗しました。"


/* PRODUCT CLASS */
/*Error Messages*/
export const ERROR_INVALID_PRODUCTCLASSCODE = "[商品分類コード]は無効です。";
export const ERROR_EMPTY_PRODUCTCLASSCODE = "[商品分類コード]を入力してください。";
export const ERROR_EMPTY_PRODUCTCLASSNAME = "[商品分類名]を入力してください。";
export const ERROR_MINIMUM_PRODUCTCLASSCODE = "[商品分類コード]は 0 以上を入力してください。";
export const ERROR_PRODUCT_CLASS_NOT_EXIST = "[商品分類]が存在しません。";
export const ERROR_PRODUCT_CLASS_RETRIEVE = "[商品分類]の取得中にエラーが発生しました。"

export const PRODCLASS = "[商品分類]";
export const ERROR_PRODCLASS_CREATE = PRODCLASS+ERROR_CREATE;
export const ERROR_PRODCLASS_UPDATE = PRODCLASS+ERROR_UPDATE;
export const ERROR_PRODCLASS_DELETE = PRODCLASS+ERROR_DELETE;

/* PRODUCT */
/*Error Messages*/
export const ERROR_INVALID_PRODUCTCODE = "[商品コード]は無効です。";
export const ERROR_EMPTY_PRODUCTCODE = " [商品コード]を入力してください。";
export const ERROR_EMPTY_PRODUCTNAME1 = "[商品名１]を入力してください。";
export const ERROR_EMPTY_PRODUCTNAME2 = "[商品名２]を入力してください。";
export const ERROR_EMPTY_PRODUCTKANA = "[フリガナ]を入力してください。";
export const ERROR_EMPTY_PRODUCTCLASS = "[商品分類]を選択してください。";
export const ERROR_MINIMUM_PRODUCTCODE = "[商品コード]は 0 以上を入力してください。"
export const ERROR_PRODUCT_NOT_EXIST = "[商品]が存在しません。";
export const ERROR_PRODUCT_RETRIEVE = "[商品]の取得中にエラーが発生しました。";

export const PRODUCT = "[商品]";
export const ERROR_PRODUCT_CREATE = PRODUCT+ERROR_CREATE;
export const ERROR_PRODUCT_UPDATE = PRODUCT+ERROR_UPDATE;
export const ERROR_PRODUCT_DELETE = PRODUCT+ERROR_DELETE;

/* USER */
/*Error Messages*/
export const ERROR_USER_NOT_EXIST = "[ユーザ]は存在しません。";
export const ERROR_USER_RETRIEVE = "[ユーザ]の取得中にエラーが発生しました。"
export const ERROR_EMPTY_USERNAME = "[ユーザ名]を入力してください。";
export const ERROR_EMPTY_LOGINID = "[ログインID]を入力してください。";
export const ERROR_EMPTY_PASSWORD = "[パスワード]を入力してください。";
export const ERROR_MINIMUM_LOGINID = "[ログインID]は 8 文字以上 16 文字以下で入力してください。";
export const ERROR_MINIMUM_PASSWORD = "[パスワード]は 8 文字以上 16 文字以下で入力してください。";
export const ERROR_LOGINID_PASSWORD = "[ログインID]と同じ[パスワード]は使用できません。";
export const ERROR_LOGINID_NEWPASSWORD = "[ログインID]と同じ[新しいパスワード]は使用できません。";
export const ERROR_NEWPASS_NEWPASS2 = "[新しいパスワード]と[新しいパスワード（確認）]が一致しません。";

export const USER = "[ユーザ]";
export const ERROR_USER_CREATE = USER+ERROR_CREATE;
export const ERROR_USER_UPDATE = USER+ERROR_UPDATE;
export const ERROR_USER_DELETE = USER+ERROR_DELETE;

/* BUSINESS PARTNER */
/*Error Messages*/
export const ERROR_SUPPLIER_NOT_EXIST = "[取引先]が存在しません。";
export const ERROR_SUPPLIER_RETRIEVE = "[取引先]の取得中にエラーが発生しました。";
export const ERROR_EMPTY_BRNCHNUM = "[取引先コード（枝番）]を入力してください。";
export const ERROR_EMPTY_MAINNUM = "[取引先コード（主番）]を入力してください。";
export const ERROR_INVALID_BRNCHNUM = "[取引先コード（枝番）]は無効です。";
export const ERROR_INVALID_MAINNUM = "[取引先コード（主番）]は無効です。";
export const ERROR_EMPTY_SUPPLIERNAME = "[取引先名]を入力してください。";
export const ERROR_EMPTY_KANA = "[フリガナ]を入力してください。";
export const ERROR_EMPTY_MAIL = "[メールアドレス]を入力してください。";
export const ERROR_EMPTY_TEL = "[電話番号]を入力してください。";
export const ERROR_EMPTY_DISP = "[予測値の表示]を選択してください。";
export const ERROR_MINMAX_BRNCHNUM = "[取引先コード（枝番）]は 0 以上 9999999999 以下で入力してください。";
export const ERROR_MINMAX_MAINNUM = "[取引先コード（主番）]は 0 以上 9999999999 以下で入力してください。";
export const ERROR_ALPHANUM_LOGINID = "[ログインID]には英数字のみが使用できます。";
export const ERROR_ALPHANUM_PASS = "[パスワード]には英数字のみが使用できます。";
export const ERROR_CHAR_TEL = "[電話番号]には数字のみが使用できます。";
export const ERROR_CHAR_MAIL = "[メールアドレス]が無効です。";
export const ERROR_CHAR_KANA = "[フリガナ]が無効です。";

export const BP = "[取引先]";
export const ERROR_BP_RETRIEVE = BP+ERROR_RETRIEVE;
export const ERROR_BP_CREATE = BP+ERROR_CREATE;
export const ERROR_BP_UPDATE = BP+ERROR_UPDATE;
export const ERROR_BP_DELETE = BP+ERROR_DELETE;

/* Order Pattern */
/*Error Messages*/
export const ERROR_ORDER_PATTERN_NOT_EXIST = "[発注制御パターン]が存在しません。";
export const ERROR_ORDER_PATTERN_RETRIEVE = "[発注制御パターン]の取得中にエラーが発生しました。";
export const ERROR_INVALID_ORDERPATTERNCODE = "[パターンコード]は無効です。";
export const ERROR_INVALID_MIN = "[最小注文数]は無効です。";
export const ERROR_INVALID_MAX = "[最大注文数]は無効です。";
export const ERROR_INVALID_MULTI = "[パターンコード]は無効です。";
export const ERROR_EMPTY_ORDERPATTERNCODE = "[パターンコード]を入力してください。";
export const ERROR_EMPTY_ORDERPATTERNNAME = "[パターン名]を入力してください。";
export const ERROR_EMPTY_MIN_MAX_MULTI = "[最小注文数]と[最大注文数]および[倍数]は、いずれか一つを入力してください。";
export const ERROR_MIN_MORE_MAX = "[最小注文数]は[最大注文数]以下でなければなりません。";
export const ERROR_EMPTY_MULTI = "[倍数]を入力してください。";
export const ERROR_MINIMUM_MINVAL = "[最小注文数]には 0 以上を入力してください。";
export const ERROR_MINIMUM_MAXVAL = "[最大注文数]には 0 以上を入力してください。";
export const ERROR_MINIMUM_MULTIVAL = "[倍数]には 0 以上を入力してください。";
export const ERROR_MINMAX_PATTERNCODE = "[パターンコード]は 0 以上 2147483645 以下で入力してください。";
export const ERROR_MULTI = "[倍数]は[最大注文数]以下でなければなりません。";

export const PTN = "[発注制御パターン]";
export const ERROR_PTN_CREATE = PTN+ERROR_CREATE;
export const ERROR_PTN_UPDATE = PTN+ERROR_UPDATE;
export const ERROR_PTN_DELETE = PTN+ERROR_DELETE;

/* PRODUCT PROPOSAL GROUP */
/*Error Messages*/
export const ERROR_PROPOSAL_NOT_EXIST = "有効な[商品提案グループ]が存在しません。";
export const ERROR_PROPOSAL_DATE_INVALID = "[商品提案終了日]は[商品提案開始日]以降で入力してください。";
export const ERROR_PROPOSAL_UNCHECK = "[商品提案グループ]は１つ以上選択してください。";
export const ERROR_EMPTY_PROPOSALID = "[グループID]を入力してください。";
export const ERROR_MAXIMUM_PROPOSALID = "グループIDは最大 3 文字です";
export const ERROR_EMPTY_PROPOSALNAME = "[グループ名]を入力してください。";
export const ERROR_EMPTY_PRICEDISPLAY = "[価格表示]を選択してください。";
export const ERROR_NEGATIVE_PRICEDISPLAY = "[価格]は 0 より大きくなければなりません。";
export const ERROR_PROPOSAL_DUPLICATE_PARTNER = "選択した[商品提案グループ]の[提案期間]内で重複する[取引先]が存在します。";
export const ERROR_STARTDATE_FORMAT = "[商品提案開始日]が無効です。";
export const ERROR_ENDDATE_FORMAT = "[商品提案終了日]が無効です。";
export const ERROR_STARTDATE_EMPTY = "[商品提案開始日]を入力してください。";
export const ERROR_CHAR_PROPOSALID = "[グループID]が無効です。";
export const ERROR_EMPTY_TIME = "[発注締切時刻]を選択してください。";

export const ERROR_SINGLE_DATE_CONFLICT = "[取引先]は[商品提案グループ]の[提案期間]内で重複しています。";
export const ERROR_DATE_CONFLICT = "以下の[取引先]は[商品提案グループ]の[提案期間]内で重複しています。";
export const ERROR_ORDER_CONFLICT = "[商品提案グループ]は以下の[受注]に存在します。";
export const ERROR_EMPTY_PATTERN = "[発注制御パターン]を選択してください。";
export const ERROR_PRODUCTLIST_EMPTY = "[商品リスト]を入力してください。";
export const ERROR_REGISTRATION = "登録は失敗しました。";
export const ERROR_EMPTY_ACTIVE_PROPOSAL = "積極的な提案はありません。";
export const SUCCESS_PROPOSAL_REGISTRATION = "[商品提案グループ編集]登録は成功しました。";
export const SUCCESS_PROPOSAL_PRODUCT_REGISTRATION = "登録は成功しました。";

export const PROPOSAL ="[商品提案グループ]";
export const ERROR_PROPOSAL_RETRIEVE = PROPOSAL+ERROR_RETRIEVE;
export const ERROR_PROPOSAL_CREATE = PROPOSAL+ERROR_CREATE;
export const ERROR_PROPOSAL_UPDATE = PROPOSAL+ERROR_UPDATE;
export const ERROR_PROPOSAL_DELETE = PROPOSAL+ERROR_DELETE;

/* CONTACT DELIVERY */
export const ERROR_CONTACT_NOT_EXIST = "[連絡先]が存在しません。";
export const ERROR_EMPTY_TITLE = "[タイトル]を入力してください。";
export const ERROR_EMPTY_MESSAGE = "[内容]を入力してください。";
export const ERROR_EMPTY_PARTNERS = "[連絡先]を入力してください。";
export const ERROR_CONTACT_RETRIEVE = "[連絡先]の取得中にエラーが発生しました。";

export const CONTACT = "[連絡先]";
export const ERROR_CONTACT_CREATE = CONTACT+ERROR_CREATE;
export const ERROR_CONTACT_UPDATE = CONTACT+ERROR_UPDATE;
export const ERROR_CONTACT_DELETE = CONTACT+ERROR_DELETE;
/* ORDER UPLOAD */
export const CSV_INVALID = "CSVは無効です。";
export const INCORRECT_FILE ="不正なファイル形式。"
export const CSV_2MB ="合計 2MBを超えるとアップロードが出来ません。"

export const ERROR_UPLOAD ="[受注データアップロード]"+ERROR_UPDATE;

/* ORDER ITEMS */
export const ERROR_ORDER_ITEMS_MONTHLY_RETRIEVE =  "[発注一覧（月間）]" + ERROR_RETRIEVE
export const ERROR_ORDER_ITEMS_DAILY_RETRIEVE = "[発注一覧（単日）]" + ERROR_RETRIEVE 
export const ERROR_ORDER_ITEMS_MONTHLY_UPDATE = "[発注一覧（月間）]" + ERROR_UPDATE 
export const ERROR_ORDER_ITEMS_DAILY_UPDATE = "[発注一覧（単日）]" + ERROR_UPDATE 

export const ERROR_ORDER_ITEMS_UPDATE = "[受注状況商品一覧]" + ERROR_UPDATE 

/* MOBILE ORDER(DAILY) */
export const WARNING_SHIPPING_INPUT = "送料を忘れずにご入力お願いします。"

/* LOGOUT */
export const CONFIRMATION_LOGOUT = "ログアウトしてもよろしいですか？";

/* POPUP */
export const RELOAD_MASTER_UPDATED = "データが更新されています。再度入力してください。";
export const CONFIRMATION_DELETE = "削除してもよろしいですか？";

export const ERROR_401 = "[ユーザ]の取得に失敗しました。";
